module.exports = __webpack_public_path__ + "img/logo.7c9c77d0.png";